<template>
    <div class="layer-list-container" v-if="selectedRelease">
        <div class="data-panel">
            <fa
              :icon="['fas', isMinimized ? 'caret-up' : 'caret-down']"
              class="data-panel__minimize"
              :title="isMinimized ? 'Expand layer list' : 'Minimize layer list'"
              @click="toggleMinimize"
            />
            <b-row no-gutters class="mb-2">
                <b-col cols="12">
                    <button class="change-region-btn" title="Change Dataset" @click="$bvModal.show('genericReleaseModal')">
                        <svg class="change-region-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.2"/>
                            <path d="M8 1.5C8 1.5 10.5 4 10.5 8S8 14.5 8 14.5M8 1.5C8 1.5 5.5 4 5.5 8S8 14.5 8 14.5M1.5 8h13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
                        </svg>
                        <span>Change Dataset</span>
                    </button>
                </b-col>
            </b-row>
            <b-row v-if="prod">
                <b-col class="layer-list-font">Production</b-col>
            </b-row>
            <b-row>
                <b-col class="layer-list-font">{{ selectedRelease.extent_description }}</b-col>
            </b-row>
            <b-row>
                <b-col class="layer-list-font">{{ selectedRelease.release_label }}</b-col>
            </b-row>
        </div>
        <div class="layers scrollable scroll-Container" v-show="!isMinimized">
            <draggable>
                <transition-group type="transition" name="flip-list">
                    <b-row
                      v-for="(element, index) in layerButtons"
                      :key="element.name"
                      :id="element.name"
                      class="layer-row"
                      :class="getLayerClass(index, element)"
                    >
                        <b-col
                          cols="10"
                          class="layer-btn"
                          :class="getLayerClass(index, element)"
                          @click="toggleLayer(element, $event)"
                        >
                          <span class="layer-row-label">{{ getLayerDisplayName(element) }}</span>
                        </b-col>
                        <b-col cols="2" class="layer-arrow layer-arrow--end">
                            <fa
                              @click="toTopOfList(element.display_name ? element.display_name : element.name)"
                              title="Move Layer To Top"
                              :icon="['fas', 'long-arrow-alt-up']"
                              class="cursor"
                            />
                            <fa
                              v-if="!selectedRelease.release_label.includes('WCL')"
                              :disabled="isLayerFilterDisabled"
                              :id="`icon${index}`"
                              @click="initFilterModal(element.name, `icon${index}`)"
                              title="Layer Filter"
                              :icon="['fas', 'filter']"
                              :class="[filterClasses[index], {'disabled-icon': isLayerFilterDisabled}]"
                            />
                        </b-col>
                    </b-row>
                </transition-group>
            </draggable>
        </div>
        <Generic_LayerFilterModal
          :layerProperties="layerProperties"
          :filter_layer="filter_layer"
          :mmp_layersObj="mmp_layersObj"
          :zoomLevelCap="zoomLevelCap"
          :generateCQLObj="generateCQLObj"
          :map="map"
          :selectedElement="selectedElement"
          @filterClassesObjChanged="$emit('filterClassesObjChanged', $event)"
          @rulesChanged="rules = $event"
        ></Generic_LayerFilterModal>
        <!-- 'layerProperties',
    'filter_layer',
    'mmp_layersObj',
    'zoomLevelCap',
    'generateCQLObj' -->
    </div>
</template>
<style src="./Generic.css" scoped></style>
<style scoped>
.layer-list-container {
    /* border: 2px solid #063c6d; */
    /* Fill down to the bottom of the screen (panel sits at top:10px, leave a
       ~10px gap at the bottom). Flex column keeps the header fixed and lets the
       layer list flex/scroll into the remaining space. Uses max-height so it
       still shrinks to fit when there are only a few layers. */
    max-height: calc(100vh - 1.25rem);
    display: flex;
    flex-direction: column;
    width: 20rem;
    border-radius: 5px;
    overflow: hidden;
    /* background-color: transparent !important; */
}
.layer-list-container .layers {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}
.data-panel {
    flex: 0 0 auto;
    width: 100%;
    background-color: #063c6d;
    color: white;
    padding: 0.75rem 0.875rem;
    font-family: 'Inter Regular', 'Open sans', sans-serif !important;
    position: relative;
 }
.data-panel__minimize {
    position: absolute;
    bottom: 8%;
    right: 6%;
    font-size: 1.375rem;
    color: #ffffff;
    cursor: pointer;
    z-index: 2;
}
.data-panel__minimize:hover {
    opacity: 0.7;
}
.layer-list-font {
    font-size: 0.8125rem !important;
    font-weight: 500;
    font-family: 'Inter Regular', 'Open sans', sans-serif !important;
}
.change-region-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    width: 100%;
    background: linear-gradient(135deg, rgba(32, 255, 155, 0.18) 0%, rgba(4, 150, 233, 0.15) 100%);
    border: 1.5px solid rgba(32, 255, 155, 0.6);
    border-radius: 8px;
    color: #20ff9b;
    font-family: 'Inter Regular', 'Open sans', sans-serif !important;
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 0.3125rem 0.625rem;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    box-shadow: 0 0 10px rgba(32, 255, 155, 0.2), inset 0 1px 0 rgba(255,255,255,0.08);
    transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
}
.change-region-btn:hover {
    background: linear-gradient(135deg, rgba(32, 255, 155, 0.32) 0%, rgba(4, 150, 233, 0.25) 100%);
    border-color: #20ff9b;
    box-shadow: 0 0 18px rgba(32, 255, 155, 0.45), 0 2px 8px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1);
    transform: translateY(-1px);
    color: #fff;
    text-shadow: 0 0 8px rgba(32, 255, 155, 0.8);
}
.change-region-btn:active {
    transform: translateY(0);
    box-shadow: 0 0 6px rgba(32, 255, 155, 0.25);
}
.change-region-icon {
    width: 0.875rem;
    height: 0.875rem;
    flex-shrink: 0;
}
.layers {
    width: 100%;
    padding: 0.5rem;
    background-color: #eef3f9;
}
.layer-btn {
    font-size: 0.8125rem !important;
    font-weight: 500;
    width: 100%;
    padding: 0.375rem 0.625rem !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.625rem;
    min-width: 0;
    color: #063c6d;
}
.layer-row-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.layer-arrow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    color: #063c6d;
    cursor: pointer !important;
}
.layer-arrow--end {
    justify-content: flex-end;
    padding-right: 0.75rem;
}
.layer-row {
    padding: 0 !important;
    margin: 0 0 0.5rem;
    width: 100%;
    min-height: 2.75rem;
    background-color: #ffffff;
    border: 1px solid rgba(6, 60, 109, 0.1);
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(6, 60, 109, 0.06);
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.2s ease, border-color 0.2s ease;
}
.layer-row:last-child {
    margin-bottom: 0;
}
.layer-row:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(6, 60, 109, 0.14);
    border-color: rgba(6, 60, 109, 0.2);
}
.available-not-enabled {
  background-color: #ffffff;
}
.available-enabled {
   background-color: #c4ead2;
  box-shadow: inset 3px 0 0 #1f9d55;
}
.unavailable {
  background-color: #eef1f4;
  opacity: 0.55;
  cursor: not-allowed;
}
.unavailable .layer-btn {
  cursor: not-allowed;
  pointer-events: none;
}
.orange-font {
  color: orange !important;
}

/* ── Scrollbar ── */
.layers.scroll-Container::-webkit-scrollbar {
  width: 5px;
}
.layers.scroll-Container::-webkit-scrollbar-track {
  background-color: transparent !important;
  box-shadow: none !important;
}
.layers.scroll-Container::-webkit-scrollbar-thumb {
  background-color: transparent !important;
  border-radius: 999px;
}
.layer-list-container:hover .layers.scroll-Container::-webkit-scrollbar-track {
  background-color: rgba(6, 60, 109, 0.06) !important;
  border-radius: 999px;
}
.layer-list-container:hover .layers.scroll-Container::-webkit-scrollbar-thumb {
  background-color: rgba(6, 60, 109, 0.25) !important;
}
.layer-list-container:hover .layers.scroll-Container::-webkit-scrollbar-thumb:hover {
  background-color: rgba(6, 60, 109, 0.5) !important;
}
</style>
<script>
import draggable from 'vuedraggable'
import {orderMapLayers} from './../../../utils/utils.js'
import { mapGetters } from 'vuex';
import axios from 'axios'
import Generic_LayerFilterModal from './Generic_LayerFilterModal.vue';
export default {
    name: 'Generic_LayerList',
    props: [
        'drtLayersButtonsCtrl',
        'wclLayersButtonsCtrl',
        'map',
        'mmp_layersObj',
        'selectedRelease',
        'filterClassesObj',
        'layerResponse',
        'zoomEnded',
        'zoomLevelCap',
        'selectedExtent',
        'persistingLayerFilters',
        'prod'
    ],
    components: {
        draggable,
        Generic_LayerFilterModal
    },
    computed: {
        ...mapGetters(['globalUserRole','globalAllowedUserModules','globalIsUserAllowed'])
    },
    data() {
        return {
            layerButtons: [],
            filterClasses: [],
            isLayerFilterDisabled: false,
            layerProperties: [],
            filter_layer: null,
            generateCQLObj: null,
            rules: [],
            extentRecentlyChanged: false,
            selectedElement: null,
            isMinimized: false
            // filterClassesObj: null,
        }
    },
    methods: {
        toggleMinimize() {
            this.isMinimized = !this.isMinimized
        },
        getLayerDisplayName(element) {
            let name = element.display_name ? element.display_name : element.name
            return name && name.toUpperCase() === 'GMFA' ? 'Functional Authority' : this.capitalizeFirstLetter(name)
        },
        capitalizeFirstLetter(str) {
            if (!str) return ""; // Handle empty strings safely
            return str.replace(/\b\w/g, char => char.toUpperCase());
        },
        getFormattedDate(originalDateString) {
            let originalDateObj = new Date(originalDateString)
            let returnValue = originalDateObj.toLocaleString('en-US', {dateStyle: 'short'}).replace(/\//g, '.')
            return returnValue
        },
        getLayerClass(index, element) {
            let mapObjs = this.mmp_layersObj
            let disabled = this.checkLayerDisable(element.name, element.zoomControl, element.minZoom)
            let displaying = this.checkLayer(mapObjs[element.name].layer)

            if (!disabled && displaying) {
                // Layer isn't disabled and layer is turned on
                return 'available-enabled'
            } else if (!disabled) {
                // Layer isn't disabled and layer is turned off
                return 'available-not-enabled'
            } else {
                // Layer is disabled
                return 'unavailable'
            }
        },
        checkLayerDisable(layerName, zoomControl, minZoom) {
            /* checkLayerDisable method returns true if zoomControl is
            enabled and the user is zoomed in far enough. */
            this.$emit('updateZoomEnded', this.map.getView().getZoom())
            let returnClass = false
            let layerExists = this.mmp_layersObj[layerName] != null
            let showLayer =
                minZoom == null
                ? this.zoomEnded >= this.zoomLevelCap
                : this.zoomEnded >= minZoom

            if (layerExists) {
                const layerObj = this.mmp_layersObj[layerName].layer
                if (!this.checkLayer(layerObj)) {
                    /* returnClass is true if zoomControl is enabled on the
                    layer and the user is zoomed in far enough. */
                    returnClass = zoomControl && !showLayer
                }
            }

            return returnClass
        },
        checkLayer(layer) {
            // Checks if layer exists on the map
            let exists = false
            let mapLayersArr = this.map.getLayers().getArray()

            switch (typeof layer) {
                case 'object':
                    for (let i in mapLayersArr) {
                        // If layer exists, return true
                        exists = mapLayersArr[i] === layer
                        if (exists) {
                            break
                        }
                    }
                    break
                case 'string':
                    for (let i in mapLayersArr) {
                        // If layer exists, return true
                        exists =
                            mapLayersArr[i].values_.hasOwnProperty('name') &&
                            mapLayersArr[i].values_.name === layer
                        if (exists) {
                            break
                        }
                    }
                    break
            }

            return exists
        },
        toggleLayer(element, event) {
            let disabled = this.checkLayerDisable(
                element.name,
                element.zoomControl,
                element.minZoom
            )
            let layerName = element.name
            if (!disabled) {
                this.$emit('toggleLayerVisibility', layerName)
                this.onEnd()
            }

            event.target.blur();
        },
        onEnd() {
            let mapObjs = this.mmp_layersObj
            orderMapLayers(mapObjs, this.layerButtons, this.map)
            this.map.getLayers().forEach(layer => {
                if (layer && layer.get('name') == this.layerButtons[0].name) {
                {
                    this.$emit('loadAttributes', {
                        name: this.layerButtons[0].name,
                        layer_group: this.layerButtons[0].layer_group,
                        response: this.layerResponse
                    })
                    this.$emit('getShowAttributes', false)
                }
                }
            })
            this.$emit('layerButtonsChanged', this.layerButtons)
            this.initFilterClasses()
        },
        toTopOfList(elementName) {
            let tool = 'DRT'

            return new Promise((resolve) => {
                this.$emit('toTopOfList', { payload: { layerName: elementName, tool }, resolve })
            }).then(() => {
                this.onEnd()
            })
        },
        initFilterClasses() {
            let tempFilterClasses = []
            for (let i in this.layerButtons) {
                let layerName = this.layerButtons[i].name
                let objToPush = {
                    cursor: true,
                    hover: false,
                    sortable: true
                }
                for (let rule in this.rules) {
                    if (this.rules[rule].layer == layerName) {
                        objToPush['orange-font'] = true
                        break
                    }
                }
                tempFilterClasses.push(objToPush)
            }
            this.filterClasses = tempFilterClasses
        },
        initFilterModal(layer, id) {
            this.selectedElement = id
            this.filter_layer = layer
            this.getFilterProperties()
            this.$bvModal.show('genericFilterModal')
        },
        getFilterProperties() {
            let layerObj = this.mmp_layersObj[this.filter_layer]
            let layerType = layerObj.layer.getSource().params_.LAYERS
            let lastItem = layerType.split(':')[0]
            let url = layerObj.geoserverName.split('?')[0] + '?'

            // Geoserver Web Feature Service
            if (sessionStorage.token) {
                axios
                .get(url, {
                    params: {
                        service: 'WFS',
                        version: '1.1.0',
                        request: 'DescribeFeatureType',
                        typename: layerType,
                        name: this.filter_layer,
                        wsName: lastItem,
                        srsname: 'EPSG:4326',
                        outputFormat: 'application/json',
                        INFO_FORMAT: 'application/json',
                        authkey: sessionStorage.token
                    }
                })
                .then(response => {
                    let tempProps = []
                    response.data.featureTypes[0].properties.forEach(item => {
                        if (['geom', 'fid'].includes(item.name)) {
                            return;
                        }
                        let obj = {
                            name: item.name,
                            display_name: item.name.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                            type: item.type.split(':')[1].trim()
                        };
                        tempProps.push(obj)
                    })
                    this.layerProperties = tempProps
                })
                .catch(function (error) {
                    console.log(error)
                })
            }
        },
    },
    mounted() {
        this.isLayerFilterDisabled = !this.globalIsUserAllowed('Filter_Modal')
        if (this.rules == []) {
            this.rules = this.persistingLayerFilters
        }
    },
    watch: {
        drtLayersButtonsCtrl: function (newValue, oldValue) {
            if (newValue.length) {
                this.layerButtons = newValue
                this.initFilterClasses()

                // this.layerButtons = newValue
                let layerButtonsLoaded = newValue.length == this.layerResponse.length
                // Checks to see if drtLayersButtonsCtrl has finished being updated
                if (layerButtonsLoaded && !this.extentRecentlyChanged) {
                    this.rules = this.persistingLayerFilters
                    this.rules.forEach(rule => {
                    /* Changing generateCQLObj will trigger a watch in MMP_LayerFilterModal.vue
                    to refresh the CQL filter for this rule when the dynamic layer list is reordered */
                    this.generateCQLObj = {
                        layer: rule.layer,
                        enableZoom: false
                    }
                    })
                } else if (layerButtonsLoaded) {
                    // This is necessary for when the dataset is swapped to a new extent
                    this.extentRecentlyChanged = false
                }
            } else {
                this.layerButtons = []
            }
        },
        wclLayersButtonsCtrl: function (newValue, oldValue) {
            if (newValue.length) {
                this.layerButtons = newValue
                this.initFilterClasses()
            } else {
                this.layerButtons = []
            }
        },
        filterClassesObj: function (newValue, oldValue) {
            Object.assign(this.filterClasses[newValue.index], newValue.passedClass)
            this.initFilterClasses()
        },
        rules: function (newValue, oldValue) {
            if (oldValue.length != 0) {
                this.$emit('rulesChanged', newValue)
            }
        },
        selectedExtent: function (newValue, oldValue) {
            this.extentRecentlyChanged = true
        }
    }
}
</script> 